$(document).ready(function () {

    $("form.RetOrderForm").live("submit", function () {

        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $form.hide();

                }
                else {

                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });
     
    $(".MoneyTransferForm #Amount").live('keyup', function (e) {

        var moneytansferAmount = $(this).val();

        var replacedVal = moneytansferAmount.replace(",", "");
        replacedVal = replacedVal.replace(",", "");
        replacedVal = replacedVal.replace(".", "");
        replacedVal = replacedVal.replace(".", "");

        if (!isNumeric(replacedVal)) {
            $(".MoneyTransferForm #Amount").val("");
        }
        else {


            var newVal = moneytansferAmount.replace(",", ".");
            newVal = newVal.replace(",", ".");

            $(".MoneyTransferForm #Amount").val(newVal);

        }

    });

    $("form.MoneyTransferForm").live("submit", function () {

        $form = $("form.MoneyTransferForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);

                    $form.find("table").hide();

                    $("#MoneyTransferResult").removeClass("alert-error");
                    $("#MoneyTransferResult").addClass("alert alert-success").show();

                }
                else {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);
                    $("#MoneyTransferResult").addClass("alert alert-error").show();
                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
         
        return false; 
    });


    $('.CancelRow select').live("change", function () {

        var TotalRet = 0;
        var CargoAmount = parseFloat($(".CargoSubTotal").val().replace(",", "."));
        var ProductTotal = 0;
        var CouponAmountLimit = $(".CouponLimit").val();
        var CouponAmount = $(".CouponSubTotal").val();

        $(".CancelRow, .CouponRow").removeClass(".WillReturn");

        $(".CancelRow input.RetSubTotal").each(function (index) {


            var retOption = $(this).closest("td").find("select").val();

            if (retOption != "" && retOption != "0") {

                TotalRet += parseFloat($(this).val().replace(",", "."));
                $(this).closest("tr").addClass("WillReturn");
            }
            else {
                $(this).closest("tr").removeClass("WillReturn");

                ProductTotal += parseFloat($(this).val().replace(",", "."));
            }


            //sepetToplami += Number($(this).val());

        });

        if (CouponAmountLimit > ProductTotal) {

            TotalRet -= CouponAmount;
            $(".CouponRow").addClass("WillReturn");
            $(".CouponWarning span").show();

        }
        else {
            $(".CouponRow").removeClass("WillReturn");
            $(".CouponWarning span").hide();
        }


        TotalRet += CargoAmount;

        $(".RetTotal").html(TotalRet.toFixed(2));
        $(".ProductTotal").html(ProductTotal.toFixed(2));


    });


    $('.changePassCancel').click(function () {
        $('.ChangePassForm input').val('');

    });

    $("a.MyOldOrdersBtn").click(function () {

        $(".MyOldOrders").show();
    });


});